<template>
  <BAsyncAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    item-text="full_name"
    item-sub-text="username"
    item-value="id"
    label="Пользователь"
    no-data-text="Пользователь не найден"
    :request="request"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from '../BAutocompleteCommon/mixins'
import { UsersApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

import BAsyncAutocomplete from '@/components/forms/BAsyncAutocomplete.vue'


export default {
  name: 'BAutocompleteUsers',
  components: {
    BAsyncAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  created() {
    const api = new UsersApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(...args) {
      return this.adapter.getAll(...args)
    },
  },
}
</script>
